/**
 * @generated SignedSource<<643d5f2df0dc2141ca1ae840049f7fff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentProgressReportFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  skillTypeIds?: ReadonlyArray<string> | null | undefined;
  targetGroupId: string;
};
export type ProgressStudentsGrowthAndEngagementQuery$variables = {
  filter: StudentProgressReportFilterInput;
};
export type ProgressStudentsGrowthAndEngagementQuery$data = {
  readonly studentProgressReport: ReadonlyArray<{
    readonly assessmentsTakenSinceLastPass: number;
    readonly currentRoadmapId: number;
    readonly currentRoadmapName: string;
    readonly lastPassedSkill: any | null | undefined;
    readonly roadmapSkillsRemaining: number;
    readonly skillsAttemptedButNotPassed: number;
    readonly skillsDemonstratedOnDiagnostic: number;
    readonly skillsPassedSinceDiagnostic: number;
    readonly student: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    };
    readonly totalAssessmentsTaken: number;
    readonly totalRoadmapSkills: number;
  }>;
};
export type ProgressStudentsGrowthAndEngagementQuery = {
  response: ProgressStudentsGrowthAndEngagementQuery$data;
  variables: ProgressStudentsGrowthAndEngagementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentProgressSummary",
    "kind": "LinkedField",
    "name": "studentProgressReport",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assessmentsTakenSinceLastPass",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentRoadmapId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentRoadmapName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastPassedSkill",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roadmapSkillsRemaining",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillsAttemptedButNotPassed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillsDemonstratedOnDiagnostic",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillsPassedSinceDiagnostic",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAssessmentsTaken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalRoadmapSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "student",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProgressStudentsGrowthAndEngagementQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProgressStudentsGrowthAndEngagementQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd1669e3a2abd2ca2bee4856ecfefdb3",
    "id": null,
    "metadata": {},
    "name": "ProgressStudentsGrowthAndEngagementQuery",
    "operationKind": "query",
    "text": "query ProgressStudentsGrowthAndEngagementQuery(\n  $filter: StudentProgressReportFilterInput!\n) {\n  studentProgressReport(filter: $filter) {\n    assessmentsTakenSinceLastPass\n    currentRoadmapId\n    currentRoadmapName\n    lastPassedSkill\n    roadmapSkillsRemaining\n    skillsAttemptedButNotPassed\n    skillsDemonstratedOnDiagnostic\n    skillsPassedSinceDiagnostic\n    totalAssessmentsTaken\n    totalRoadmapSkills\n    student {\n      firstName\n      id\n      lastName\n      publicUserId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd71f94a520b10f51ecbb3a868e659c7";

export default node;
